import QuickViewModal from "./QuickViewModal";
export default QuickViewModal;
